import {AbstractLayer, EditMode} from '../../core/layers/abstract.layer';
import {SwitchLayer} from '../../core/layers/switch.layer';
import {AbstractTool} from './abstract.tool';
import { Point } from '/src/core/point';
import {LVGLPlatform} from '/src/platforms/lvgl';

export class SwitchTool extends AbstractTool {
    name = 'switch';
    title = 'Switch';

    createLayer(): AbstractLayer {
        const {session} = this.editor;
        const renderer = session.createRenderer();
        return new SwitchLayer(session.getPlatformFeatures(), renderer);
    }

    onActivate(): void {
        const {layersManager, state} = this.editor.session;
        layersManager.clearSelection();
        let layer: SwitchLayer = this.createLayer() as SwitchLayer;
        this.editor.state.activeLayer = layer;
        this.editor.session.addLayer(this.editor.state.activeLayer as AbstractLayer);
        // Center the default switch size on the display.
        const position = new Point((state.display.x - 50) / 2, (state.display.y - 25) / 2).round();
        this.editor.state.activeLayer.startEdit(EditMode.CREATING, position);
        this.editor.state.activeLayer.stopEdit();
        layersManager.selectLayer(layer);
        this.editor.setTool(null);
        this.editor.session.virtualScreen.redraw();
    }
    
    isSupported(platform: string): boolean {
        return [LVGLPlatform.id].includes(platform);
    }
}
